import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export class GetModelDetailRelevantAdsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Config} deps.config
   */
  constructor({config, httpAdsRepository, getModelDetailRelevantAdsRequestVO, motosNotImplementedError}) {
    super({config, httpAdsRepository})
    this._config = config
    this._httpAdsRepository = httpAdsRepository
    this._getModelDetailRelevantAdsRequestFactory = getModelDetailRelevantAdsRequestVO
    this._isMotos = this._config.get('APP_NAME') === this._config.get('APP_NAME_MOTOS')
    this._motosNotImplementedError = motosNotImplementedError
  }

  @tracer({metric: 'GetModelDetailRelevantAdsUseCase#execute'})
  @inlineError
  async execute(params = {}) {
    if (this._isMotos) {
      return Promise.reject(this._motosNotImplementedError('Motos use case not implemented'))
    }

    const {page = 1, sortBy = this._defaultSortBy, sortOrder = this._defaultSortOrder, variant, ...restParams} = params
    const searchRequestObjectValueObject = this._getModelDetailRelevantAdsRequestFactory({
      page,
      sortBy,
      sortOrder,
      ...restParams
    })
    const [getModelDetailRelevantAdsServiceError, getModelDetailRelevantAdsServiceResponse] =
      await this._httpAdsRepository.getModelDetailRelevantAds({
        searchRequestObjectValueObject
      })

    return getModelDetailRelevantAdsServiceError
      ? Promise.reject(getModelDetailRelevantAdsServiceError)
      : getModelDetailRelevantAdsServiceResponse.toJSON()
  }
}
